import {createAction, props} from '@ngrx/store';
import { Message, TextMessage, MediaUploadDetails, MediaMessage } from '../../models/chat.state';


export const loadChat = createAction(
    '[Chat] Load Chat'
  );
  
  export const loadChatSuccess = createAction(
    '[Chat] Load Chat Success',
    props<{ messages: Message[] }>()
  );
  
  export const loadChatFailure = createAction(
    '[Chat] Load Chat Failure',
    props<{ error: string }>()
  );

  export const sendMessage = createAction(
    '[Chat] Send Message',
    props<{ message: TextMessage }>()
  );
  
  export const sendMessageSuccess = createAction(
    '[Chat] Send Message Success',
    props<{ message: Message }>()
  );
  
  export const sendMessageFailure = createAction(
    '[Chat] Send Message Failure',
    props<{ error: string }>()
  );

export const getMediaUploadUrl = createAction(
  '[Chat] Get Media Upload Url',
  props<{ service_id: number, file_name: string, file: File | any }>()
);

export const updateMediaMessage = createAction(
  '[Chat] Update Media Message',
  props<{ mediaMessage: MediaMessage, file: File | any }>()
);

export const getMediaUploadUrlSuccess = createAction(
  '[Chat] Get Media Upload Url Success',
  props<{ mediaUploadDetails: MediaUploadDetails }>()
);

export const getMediaUploadUrlFailure = createAction(
  '[Chat] Get Media Upload Url Failure',
  props<{ error: string }>()
);

export const uploadFileToServerSuccess = createAction(
  '[Chat] Upload File To Server Success',
  props<{ mediaUploadDetails: MediaUploadDetails }>()
);

export const uploadFileToServerFailure = createAction(
  '[Chat] Upload File To Server Failure',
  props<{ error: string }>()
);


export const sendMediaMessageSuccess = createAction(
  '[Chat] Send Media Message Success',
  props<{ mediaMessage: MediaMessage }>()
);

export const sendMediaMessageFailure = createAction(
  '[Chat] Send Media Message Failure',
  props<{ error: string }>()
);

export const startSseConnection = createAction(
  '[Chat] Start SSE Connection'
);

export const startSseConnectionSuccess = createAction(
  '[Chat] Start SSE Connection Success',
);

export const startSseConnectionFailure = createAction(
  '[Chat] Start SSE Connection Failure',
  props<{ error: string }>()
);

export const receiveMessage = createAction(
  '[Chat] Receive Message',
  props<{ service_id: number }>()
);

export const receiveMessageFailure = createAction(
  '[Chat] Receive Message Failure',
  props<{ error: string }>()
);

export const clearMessageRead = createAction(
  '[Chat] Clear Message Read',
  props<{ service_id: number }>()
);
